import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FourSightContentRequest } from '../../lib/foursightContent-api';

const initialState = {
  matches: [],
  isLoading: false,
  error: null,
  loadedMatchId: null,
};

export const fetchFourSightContent = createAsyncThunk(
  'fourSightContent/fetch',
  async matchId => {
    const request = new FourSightContentRequest(matchId);
    const matches = await request.get();
    return { matches, matchId };
  },
  {
    condition: (matchId, { getState }) => {
      const { fourSightContent } = getState();
      // Skip if already loading (prevent concurrent requests)
      return !fourSightContent.isLoading;
    },
  },
);

const fourSightContentSlice = createSlice({
  name: 'fourSightContent',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchFourSightContent.pending, state => ({
        ...state,
        isLoading: true,
        error: null,
      }))
      .addCase(fetchFourSightContent.fulfilled, (state, action) => ({
        ...state,
        isLoading: false,
        error: null,
        matches: action.payload.matches,
        loadedMatchId: action.payload.matchId,
      }))
      .addCase(fetchFourSightContent.rejected, (state, action) => ({
        ...state,
        isLoading: false,
        error: action.error.message,
      }));
  },
});

export default fourSightContentSlice.reducer;

export const getFourSightTournamentMatches = state => state.matches;
export const getFourSightContentLoading = state => state.isLoading;
